import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import PaymentCardFields, { CARD_BILLING_POSTCODE_SELECTOR, CARD_FIELDSET_SELECTOR } from '../PaymentCardFields';
import PaymentMethodSelector from '../PaymentMethodSelector';

const CLICK_EVENT = 'click';

class CheckoutComponent extends FormComponent {
    set error(error) {
        this._error = error;
        this.render();
        this.initiatePaymentCardFields();
    }

    get error() {
        return this._error;
    }

    markup(value, rowData, titleMarkup) {
        return `
            <div class="lta-checkout-component">
                <div class="lta-checkout-component__form-wrapper">
                    <div class="lta-checkout-component__title u-w-100 u-hidden md:u-block">${titleMarkup}</div>
                    <hr class="u-mb-3"/>
                    <form id="payment" class="js-lta-payment-checkout lta-checkout-component__form u-w-100 u-pr-2" data-provider="lta_payment">
                        <div class="p-checkout__error-container ${this.error ? 'u-block' : 'u-hidden'}">
                            <div class="u-mb-2 xl:u-mb-5">
                                <div class="lta-snackbar lta-snackbar--alert u-mb-0 data-alert">
                                    <p class="lta-snackbar__label title" aria-label="The course that you have selected is now fully booked." onclick="">${this.error}</p>
                                    <div class="lta-snackbar__icon">
                                        <svg class="lta-icon js-lta-text-input--btn-icon" width="1em" height="1em" fill="currentColor" alt="alert" aria-hidden="true">
                                            <use xlink:href="/static/images/icons/lta-icons.svg#alert"></use>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="payment-methods u-pb-5 u-border-bottom">
                            <label class="u-mb-1 u-block u-body2 u-text-grey-ui-mid">Payment Method</label>
                            <div class="saved-cards-details u-hidden">
                                <div class="saved-cards-list">
                                    <div class="lta-text-input--error"></div>
                                </div>
                                <div class="add-another-card u-mb-2">
                                    <button
                                        type="button"
                                        class="lta-btn lta-btn--lg lta-btn--link add-another-card--button u-text-lta-blue"
                                    >
                                        Or add another card to pay with
                                    </button>
                                </div>
                            </div>
                            <div class="payment-method-selector-wrapper u-px-3">
                                <div class="payment-method-card">
                                    <div id="flexRadioForm" class="lta-form-check u-py-2 u-px-4 u-border-bottom">
                                        <input
                                            class="lta-form-check-input"
                                            type="radio"
                                            name="payment-method"
                                            id="card-input"
                                            value="card"
                                            checked=""
                                            data-title="Title"
                                            data-description="DataDescription"
                                        />
                                        <label class="lta-form-check-label" for="card-input">Credit / Debit Card</label>
                                    </div>
                                    <div class="u-px-2 u-pt-2">
                                        <fieldset id="${CARD_FIELDSET_SELECTOR}" data-provider="lta_payment">
                                            <div id="card-number" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-number-element" class="lta-text-input__label">
                                                    Card Number
                                                </label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div class="icon-overlay-wrapper">
                                                    <div id="card-number-element" class="u-block"></div>
                                                    <div class="icon-overlay">
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-visa"
                                                            aria-hidden="true"
                                                            data-brand="visa"
                                                        >
                                                            <use
                                                            xlink:href="/static/images/icons/lta-icons.svg#card-visa"
                                                            ></use>
                                                        </svg>
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-mastercard"
                                                            aria-hidden="true"
                                                            data-brand="mastercard"
                                                        >
                                                            <use xlink:href="/static/images/icons/lta-icons.svg#card-mastercard"></use>
                                                        </svg>
                                                        <svg
                                                            class="card-type-icon"
                                                            width="24px"
                                                            height="16px"
                                                            style="color: currentColor"
                                                            fill="currentColor"
                                                            alt="card-amex"
                                                            aria-hidden="true"
                                                            data-brand="amex"
                                                        >
                                                            <use xlink:href="/static/images/icons/lta-icons.svg#card-amex"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="card-expiry" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-expiry-element" class="lta-text-input__label">Expiry Date</label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div id="card-expiry-element" class="u-block"></div>
                                            </div>
                                            <div id="card-cvc" class="lta-text-input__wrapper u-mb-3">
                                                <label for="card-cvc-element" class="lta-text-input__label">CVC</label>
                                                <div class="lta-text-input--error u-hidden"></div>
                                                <div class="icon-overlay-wrapper">
                                                    <div id="card-cvc-element" class="u-block"></div>
                                                    <div class="icon-overlay">
                                                        <img
                                                            alt="Card CVC location"
                                                            title=""
                                                            width="30px"
                                                            height="25px"
                                                            src="/static/images/icons/card-cvc.png"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="card-postalcode" class="lta-text-input__wrapper u-mb-3">
                                                <label
                                                    for="${CARD_BILLING_POSTCODE_SELECTOR}"
                                                    class="lta-text-input__label">
                                                        Billing Postcode
                                                </label>
                                                <div class="lta-text-input--error u-hidden">
                                                    Please enter a valid UK postcode
                                                </div>
                                                <input
                                                    type="text"
                                                    class="lta-text-input"
                                                    id="${CARD_BILLING_POSTCODE_SELECTOR}"
                                                    placeholder="Postcode"
                                                />
                                            </div>
                                        </fieldset>                                        
                                    </div>
                                </div>
                                <div class="payment-method-wallet">
                                    <div id="wallet-form" class="lta-form-check u-py-2 u-px-4 u-hidden">
                                        <input
                                            class="lta-form-check-input"
                                            type="radio"
                                            name="payment-method"
                                            id="wallet-input"
                                            value="wallet"
                                            data-title="Title"
                                            data-description="DataDescription"
                                        />
                                        <label class="lta-form-check-label" for="wallet-input">Wallet
                                        <span class="lta-form-check__label-instruction">Wallet Icon Placeholder</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="lta-checkout-component__summary-info u-mb-3 md:u-hidden u-mt-3">
                            ${rowData?.agreementText ?? ""}
                        </div>
                        <div class="lta-checkout-component__summary-button md:u-hidden u-mb-3">
                            <button type="submit" id="js-checkout-component__payment-btn-mobile" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block">Pay now</button>
                        </div>
                    </form>
                </div>
                <div class="lta-checkout-component__summary u-bg-background-blue">
                    <div class="lta-checkout-component__summary-container">
                        <div class="lta-checkout-component__title u-w-100 md:u-hidden">${titleMarkup}</div>
                        <p class="lta-checkout-component__summary-title">${rowData?.count === 1 ? '1 child' : `${rowData.count} children`}</p>
                        <div class="lta-checkout-component__summary-price u-mb-3">
                            <p>Total Price</p>
                            <p>£${rowData.total}</p>
                        </div>
                        <hr class="u-mb-3"/>
                        <div class="lta-checkout-component__summary-info u-mb-3 u-hidden md:u-block">
                            ${rowData?.agreementText ?? ""}
                        </div>
                        <div class="lta-checkout-component__summary-button u-hidden md:u-flex">
                            <button type="submit" id="js-checkout-component__payment-btn" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block">Pay now</button>
                        </div>
                    </div>
                </div>
                <div id="payment-request-button" classes="u-hidden" />
            </div>
        `;
    }

    renderTitle(title) {
		return title ? `<div class="lta-heading-title u-mb-5 sm:u-mb-3">${title}</div>` : '';
	}

    afterRender() {
        this.paymentMethodSelector = SelectorEngine.findOne('.js-lta-payment-checkout', this._element);
        this.cardFieldset = SelectorEngine.findOne(`#${CARD_FIELDSET_SELECTOR}`, this._element);
        this.paymentBtn = SelectorEngine.findOne('#js-checkout-component__payment-btn', this._element);
        this.paymentBtnMobile = SelectorEngine.findOne('#js-checkout-component__payment-btn-mobile', this._element);
        this.cardPostalCode = SelectorEngine.findOne(`#${CARD_BILLING_POSTCODE_SELECTOR}`, this._element);
        
        this.initEvents();
        if(this.paymentMethodSelectorInstance) {
            this.initiatePaymentCardFields();
        }
    }

    initPayment() {
        try {
            this.initPaymentSelector();
            this.initiatePaymentCardFields();
        } catch(error) {
            console.error(error);
        }
    }

    initPaymentSelector() {
        if (this.paymentMethodSelector) {
            if (!this.paymentMethodSelectorInstance) {
                this.paymentMethodSelectorInstance = PaymentMethodSelector.getOrCreateInstance(this.paymentMethodSelector);
            }
        } else {
            throw new Error('Payment method selector not found');
            return;
        }
    }

    initiatePaymentCardFields() {
        if(this.cardFieldsetInstance) {
            this.cardFieldsetInstance?.destroy();
            delete this.cardFieldsetInstance;
        }
        if(this.cardFieldset) {
            this.cardFieldsetInstance = new PaymentCardFields(this.cardFieldset);
        }
    }

    initEvents() {
        if (this.paymentBtn) {
            EventHandler.on(this.paymentBtn, CLICK_EVENT, this.paymentHandler.bind(this));
        }
        if (this.paymentBtnMobile) {
            EventHandler.on(this.paymentBtnMobile, CLICK_EVENT, this.paymentHandler.bind(this));
        }
    }

    paymentHandler(event) {
		this.togglePaymentButtons(true);
        event.preventDefault();
        this?.paymentMethodSelectorInstance?.cardPaymentAsync({
            name: this.data?.userDetails?.name,
            email: this.data?.userDetails?.email,
            cardElements: this.cardFieldsetInstance?.getElements()
        }, this.paymentSuccessHandler.bind(this), this.paymentErrorHandler.bind(this));
    }


    paymentSuccessHandler(paymentIntentId, afterAuthentication) {
        this.value = { value: paymentIntentId, fieldName: this?.data.fieldName, };
        this.error = null;
        return this.data.onSuccess && this.data.onSuccess(afterAuthentication);
    }
    
    paymentErrorHandler(error) {
        console.log('error', error);
        this.error = (typeof error === 'string' ? error : error?.message) || "Something went wrong";
        this.togglePaymentButtons(false);
    }
    
    togglePaymentButtons(disabled) {
        this.paymentBtn.disabled = disabled;
        this.paymentBtnMobile.disabled = disabled;
    }

    validate() {
        return !!this.value?.value;
    } 
}
export default CheckoutComponent;
